import { render, staticRenderFns } from "./Foot375.vue?vue&type=template&id=1b440bfa&scoped=true"
import script from "./Foot375.vue?vue&type=script&lang=js"
export * from "./Foot375.vue?vue&type=script&lang=js"
import style0 from "./Foot375.vue?vue&type=style&index=0&id=1b440bfa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b440bfa",
  null
  
)

export default component.exports